import {Component, EventEmitter, Input, Output} from '@angular/core';
import {getDeepCopyOfObject} from '../../../shared-utils/object/object.utils';
import {IDebtorDetails} from '../../../../features/quotes/models/debtors';

/**
 * Component for editing debtor/supplier information for quotes.
 * Displays a form with editable fields and emits combined data on save.
 */
@Component({
  selector: 'app-shared-debtor-editor',
  templateUrl: './shared-debtor-editor.component.html',
  styleUrls: ['./shared-debtor-editor.component.scss'],
  standalone: false,
})
export class SharedDebtorEditorComponent {

  @Input() modalTitle = 'Edit Debtor Information';
  @Input() buttonAcceptText = 'Save';
  @Input() buttonCloseText = 'Cancel';

  @Output() readonly debtorSaved = new EventEmitter<IDebtorDetails>();
  @Output() readonly editorCancelled = new EventEmitter<void>();
  @Output() readonly debtorChange = new EventEmitter<void>();

  today: string = new Date()?.toLocaleString('en-UK', {
    dateStyle: 'short',
  });

  /**
   * Editable copy of debtor data.
   */
  debtorData: IDebtorDetails;

  @Input() set debtor(debtor: IDebtorDetails) {
    this.debtorData = {
      ...getDeepCopyOfObject(debtor),
      account: debtor.debtorId,
    };
  }

  /**
   * Handles save button click.
   * Emits the edited debtor data.
   */
  onSaveClick(): void {
    this.debtorSaved.emit(this.debtorData);
  }

  /**
   * Handles cancel button click.
   * Emits cancel event.
   */
  onCancelClick(): void {
    this.editorCancelled.emit();
  }

  onDebtorChangeClick(): void {
    this.debtorChange.emit();
  }

}
